import { USPCards, USPCardSettings } from '@models/api.models';
import { UspCard } from '@features/product/product.models';

export const getUspCard = (uspCardSettings?: USPCardSettings, pageId?: string | null): UspCard[] | undefined => {
    if (!uspCardSettings?.uspCards?.length || !pageId) {
        return [];
    }

    const filteredCards = uspCardSettings.uspCards.filter(card => getReferenceCardParent(card, pageId));
    return filteredCards as UspCard[];
};

const getReferenceCardParent = (card: USPCards, pageId: string) => card?.references?.some(ref => ref?.key === pageId);
